module.exports = __webpack_public_path__ + "static/media/calendar.53795477.svg";